import { Container } from "reactstrap";
import Helmet from "react-helmet";
import styles from "./styles.module.scss";

export const GreatRecruitersWidget = ({
  className,
  bgColor = "",
}) => {
  return (
    <>
      <Helmet>
        <script
          type="text/javascript"
          async
          defer
          crossorigin="anonymous"
          src="https://app.greatrecruiters.com/companies/89e80178f66dda891063e355b03875ab78322e99/pinned_reviews"
        />
      </Helmet>
      <section className={`${styles.root} ${className} ${bgColor}`}>
        <Container>
          <div id="gr-pinned-reviews" className={bgColor}>
            <div className={`reviews ${bgColor}`}></div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default GreatRecruitersWidget;
